export const getSliderColProps = (bigScreen?: boolean) => ({
  xs: 24,
  sm: 24,
  md: 24,
  lg: bigScreen ? 12 : 24,
  xl: bigScreen ? 12 : 24,
});
